import browserizr, { isAndroid, isIOS } from "@wezom/browserizr";
/** @ts-ignore */
import { getWechat } from "@omc/browserizr";

const isAndroidEnv = () => browserizr.detect(isAndroid);

const isIOSEnv = () => browserizr.detect(isIOS);

const isWechatEnv = () => {
  const userAgent: any = navigator.userAgent.toLowerCase();
  return Boolean(
    userAgent.indexOf("micromessenger") > -1 ||
    userAgent.indexOf("wechat") > -1 ||
    userAgent.indexOf("wechatdevtools") > -1 ||
    getWechat()
  );
};

const isInApp = () => {
  const userAgent: any = navigator.userAgent.toLowerCase();
  return userAgent.includes("mcd-ios") || userAgent.includes("mcd-android") || userAgent.includes('mcd-harmony');
};

const isOpenHarmony = () => {
  const userAgent: any = navigator.userAgent.toLowerCase();
  return userAgent.includes('openharmony');
};

const getCDNHost = () => {
  const hostName = window.location.hostname;
  let configHost = '';
  switch (hostName) {
    case 'localhost':
      configHost = 'https://cdn-sit.mcdchina.net';
      break;
    case 'm-sit.mcdchina.net':
      configHost = 'https://cdn-sit.mcdchina.net';
      break;
    case 'm-uat.mcdchina.net':
      configHost = 'https://cdn-uat.mcdchina.net';
      break;
    default:
      configHost = 'https://cdn.mcd.cn';
  }
  return configHost
};

export { isAndroidEnv, isIOSEnv, isWechatEnv, isInApp, isOpenHarmony, getCDNHost };
